import React, { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';
import 'swiper/css/navigation';
import "swiper/css";
import "./Product_details_slider.css";

function Product_details_slider({ images, title, types }) {
    const [selectedImage, setSelectedImage] = useState(images[0]);

    return (
        <section className='Product_details_slider'>
            <div className="container">
                <div className="details_content_holder row">
                    <div className="col-md-4 col-sm-6 ">
                        <div className='main_img_holder'>
                            <div className="img_holder">
                                <img className="product_img" src={process.env.PUBLIC_URL + selectedImage} alt={title} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 col-sm-6">
                        <div className='heading_holder'>
                            <h2>{title}</h2>
                            <h4>Available Types:</h4>
                        </div>


                        {types && (
                            <div className="tab_box_holder">
                                <div className="row">
                                    {types.map((type, index) => (
                                        <div key={index} className="col-xl-4 col-md-6 col-sm-12">
                                            <div className={`box_holder ${index === 0 ? 'active' : ''}`}>
                                                <div>
                                                    <h4>{type.title}</h4>
                                                    <p>{type.desc}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}


                        {/* Swiper */}
                        <div className='swiper_hodler'>
                            <Swiper
                                className="product_mySwiper"
                                slidesPerView={4.5}
                                spaceBetween={15}
                                navigation
                                loop
                                modules={[Navigation]}
                                breakpoints={{
                                    320: { slidesPerView: 3.5 },
                                    768: { slidesPerView: 5.5 },
                                    1200: { slidesPerView: 4.5 },
                                }}
                            >
                                {images.map((img, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div className='img_holder' onClick={() => setSelectedImage(img)}>
                                            <img className="product_img" src={process.env.PUBLIC_URL + img} alt={`img-${idx}`} />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Product_details_slider;
